import { render, staticRenderFns } from "./SummaryList.vue?vue&type=template&id=40481452&scoped=true&"
import script from "./SummaryList.vue?vue&type=script&lang=js&"
export * from "./SummaryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40481452",
  null
  
)

export default component.exports